<template>
<section class="banner__breadcumn ralt">

        <!--Search Popup-->
        <div id="searchPopup" class="search__popup">
            <form action="#" class="popup-content d-flex align-items-center">
                <input type="text" placeholder="Search Here">
                <button id="closeButton">
                    <i class="bi bi-x-lg"></i>
                </button>
            </form>
        </div>
        <!--Search Popup-->
        <div class="breadcumnd__wrapper">
            <div class="container">
                <div class="profile__wrapper">
                    <div class="row g-4 align-items-center justify-content-between">
                        <div class="col-xxl-6 col-xl-6 col-lg-7 col-md-7 col-sm-7">
                            <div class="breadcumnd__content">
                                <span class="d41 mb-24">
                                    Xalqaro Hamkorlar
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  <div class="article-list">
    <h1 class="title">Xalqaro Hamkorlar</h1>

    <p class="description">
    Xalqaro faoliyatda “O‘zbekiston pochtasi” AJ uchun O‘zbekiston Respublikasining Umumjahon pochta ittifoqiga (UPI) a’zoligi muhim ahamiyatga ega.
    </p>
  <p class="description">
  Oʻzbekiston Respublikasi 1994-yil 24-fevralda UPIga aʼzo boʻlgan va uning faoliyatida ishtirok etmoqda. UPIga aʼzolik Oʻzbekiston Respublikasiga UPIga aʼzo mamlakatlarning tayinlangan operatorlari bilan oʻzaro hamkorlikni taʼminlash, yagona pochta hududida yagona standartlar va texnologiyalar asosida pochta joʻnatmalarining erkin aylanishini kafolatlash imkonini berdi.
  </p>
  <p class="description">
UPI hujjatlari UPIga a’zo mamlakatlarning o‘zaro hamkorligi va hamkorligi hamda “O‘zbekiston pochtasi” AJning tayinlangan operatorining boshqa davlatlarningtayinlangan operatorlari bilan pochta jo‘natmalari va pochta pul o‘tkazmalari almashinuvi uchun normativ-huquqiy asos hisoblanadi.
   </p>
<p class="description">
O‘zbekiston Respublikasi dunyoning 100 dan ortiq mamlakatlari bilan pochta jo‘natmalari almashinuvini amalga oshiradi.   </p>
<p class="description">
“O‘zbekiston pochtasi” AJ UPI qoshida tashkil etilgan Telematika kooperativining a’zosi bo‘lib, shuning uchun O‘zbekiston pochta texnologiyalari markazi tomonidan ishlab chiqilgan dasturiy mahsulotlardan 30% chegirma bilan foydalanish huquqiga ega.
</p>

<h1 class="title">Aloqa sohasida mintaqaviy hamdo'stlik</h1>

    <p class="description">
   “O‘zbekiston pochtasi” AJ Aloqa sohasida Mintaqaviy Hamdo‘stlik a’zosi hisoblanadi. Aloqa sohasida mintaqaviy hamdo‘stlikga MDH davlatlari va Litva, Latviya, Sloveniya va Estoniya kuzatuvchi sifatida kiradi.
    </p>
<p class="description">
Aloqa sohasida mintaqaviy hamdo‘stlik UPI mintaqaviy loyihalarini amalga oshirishda muvofiqlashtiruvchi vazifasini bajaradi. Aloqa sohasidagi mintaqaviy hamdo'stlik barcha hamkorlik qiluvchi tomonlar uchun yagona platforma boʻlib, mintaqadagi ishtirokchi mamlakatlarga quyidagi masalalar boʻyicha yagona ustuvor yo'nalishlarga asoslangan umumiy vazifalarni hal qilish imkonini beradi:
    </p>
<div class="management-section">
      <ul class="management-list">
        <li>Pochta aloqasi ekspluatatsiyasi masalalarida o'zaro hamkorlikni tashkil etish;</li>
        <li>Pochta aloqasining texnik siyosati, yangi xizmatlar va ilg‘or texnologiyalarni joriy etish sohasida hamkorlik qilish;</li>
        <li>Pochta aloqasi operatorlari o‘rtasidagi pochta aloqasi xizmatlari uchuno‘zaro hisob-kitoblar tamoyillari va intizomini takomillashtirish. Tarif siyosatini shakllantirish bo'yicha tajriba almashish;</li>
        <li>Kadrlarni tayyorlash, qayta tayyorlash va malakasini oshirish;</li>
        <li>Xalqaro tashkilotlar tomonidan ko‘rib chiqiladigan pochta masalalari bo‘yicha Aloqa sohasidagi mintaqaviy hamdo‘stlik pochta operatorlari kengashi a’zolari – operatorlarning kelishilgan pozitsiyalarini ishlab chiqish va boshqalar.</li>
      </ul>
    </div>
<p class="description">
“O‘zbekiston pochtasi” AJ Aloqa sohasidagi hududiy hamdo‘stlik ishchi organlari: pochta komissiyasi va pochta aloqasi operatorlari kengashining qo‘shma majlislarida faol ishtirok etadi. 2012-yildan buyon “O‘zbekiston pochtasi” AJ Bosh direktori Aloqa sohasidagi mintaqaviy hamdo‘stlik pochta operatorlari kengashiga raislik qilib kelmoqda.
  </p>
<p class="description">
Aloqa sohasidagi hududiy hamdo‘stlik doirasida “O‘zbekiston pochtasi” AJ “Elektron tijoratga operativ tayyorgarlik” O‘zbekiston strategik mintaqaviy loyihalarini va EAD ning dastlabki elektron ma’lumotlarini to‘plash, uzatish va talablariga rioya qilish loyihasini amalga oshirishda ishtirok etadi.
  </p>

<h1 class="title">Ikki tomonlama hamkorlik</h1>

    <p class="description">
“O‘zbekiston pochtasi” AJ tomonidan ko‘rsatilayotgan xizmatlar ko‘lamini kengaytirish maqsadida pochta aloqasi operatorlari va xususiy kompaniyalar bilan ikki tomonlama hamkorlikka oid uchrashuvlar o‘tkazildi. Muzokaralar natijasida bugungi kunga qadar elektron tijoratni rivojlantirish maqsadida Belarus, Qozog‘iston, Rossiya, Ukraina pochta operatorlari bilan pochta jo‘natmalarini Internet-buyurtmalar bilan yetkazib berish bo‘yicha ikki tomonlama shartnomalar tuzildi. Xuddi shunday shartnomalar Post+ BV, Tiger Line Post va boshqa xususiy kompaniyalari bilan ham tuzilgan.    </p>
  </div>
</template>

<style scoped>
.article-list {
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background-color: #f8f9ff;
  border-radius: 8px;
  font-family: system-ui, -apple-system, sans-serif;
}

.title {
  color: #1a47b8;
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  line-height: 1.3;
  font-weight: 600;
}

.description {
  color: #333;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
}

.subtitle {
  color: #333;
  font-size: 1.3rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.management-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.management-list li {
  color: #333;
  font-size: 1.1rem;
  padding: 0.5rem 0;
  position: relative;
  padding-left: 1.5rem;
  transition: transform 0.2s ease;
}

.management-list li:hover {
  transform: translateX(5px);
}

.management-list li::before {
  content: "-";
  position: absolute;
  left: 0;
  color: #1a47b8;
}

@media (max-width: 768px) {
  .container {
    padding: 1rem;
    margin: 1rem;
  }

  .title {
    font-size: 1.5rem;
  }

  .description, .management-list li {
    font-size: 1rem;
  }
}
</style>